import { memo, forwardRef, useCallback, useMemo } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";

const DateTimeFilterInput = forwardRef(({ item, apiRef, applyValue, inputRef, type, className, sx, slotProps, ...props }, ref) => {
	const InputComponent = type === 'date' ? DatePicker : DateTimePicker;
	const value = useMemo(() => {
		if (item.value) {
			const valueObj = dayjs(item.value);
			if (valueObj.isValid()) {
				return valueObj;
			}
		}
		return null;
	}, [item?.value]);


	const handleOnChange = useCallback((newValue) => {
		let processedValue = newValue;
		if (newValue && dayjs(newValue).isValid()) {
			if (type === 'date') {
				// For date filters, use start of day in local timezone to avoid timezone shifts
				processedValue = dayjs(newValue).startOf('day');
			}
		}
		applyValue({
			...item,
			value: typeof processedValue === 'undefined' ? null : processedValue
		});
	}, [item, type, applyValue]);

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			<InputComponent
				slotProps={{
					textField: {
						margin: 'none',
						size: 'small',
						inputRef,
						sx: {
							height: '37px !important',
							maxHeight: '37px !important',
						}
					}
				}}
				value={value} onChange={handleOnChange}
				ref={ref}
				label="Is"
				views={type === 'date' ? ['year', 'month', 'day'] : ['year', 'month', 'day', 'hours', 'minutes', 'seconds']}
				timeSteps={{ hours: 1, minutes: 1, seconds: 1 }}
				localeText={{ fieldMonthPlaceholder: (params) => params.contentType === 'digit' ? 'MM' : 'MMM'}} // To override the default mui month placeholder
				{...props}
			/>
		</LocalizationProvider>
	);
});

export default memo(DateTimeFilterInput)